module.exports = __webpack_public_path__ + "img/content_bg.a168e075.jpg";